import pxToRem from "theme/base/pxToRem";
import typography from "theme/base/typography";
import colors from "theme/theme-light/colors";

const dayCalendar = {
  styleOverrides: {
    root: {
      ".MuiDayCalendar-slideTransition": { minHeight: pxToRem(200) },
      ".Mui-selected": {
        // backgroundColor:`${colors.background.bgBrand} !important`,
      },
      ".MuiDayCalendar-weekDayLabel": {
        color: colors.text.textLink,
        fontSize: typography.size.md_16,
        fontWeight: typography.fw_semibold_500,
      },
    },
  },
};

export default dayCalendar;
